/* unplugin-vue-components disabled */import { render } from "./glpInstructions03.vue?vue&type=template&id=10f72e0a&scoped=true"
import script from "./glpInstructions03.vue?vue&type=script&lang=js"
export * from "./glpInstructions03.vue?vue&type=script&lang=js"

import "./glpInstructions03.vue?vue&type=style&index=0&id=10f72e0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f72e0a"]])

export default __exports__